import { Redirect } from "react-router";
import Login from "../views/Auth/Login/Login";
import Register from "../views/Auth/Register/Register";
import RequestPassword from "../views/Auth/RequestPassword/RequestPassword";
import Contact from "../views/Contact/Contact";
import Home from "../views/Home/Home";
import ListOfServicesPerCategory from "../views/ListOfServicesPerCategory/ListOfServicesPerCategory";
import AlcaldiaView from "../views/AlcaldiaView/AlcaldiaView";
import AlcaldiasList from "../views/AlcaldiasList/AlcaldiasList";
import MyDesk from "../views/MyDesk/MyDesk";
import { PolicyPrivacy } from "../views/PolicyPrivacy/PolicyPrivacy";
//import RequestedServiceList from "../views/RequestedServiceList/RequestedServiceList";
import RequestService from "../views/RequestService/RequestService";
import ServiceDescription from "../views/ServiceDescription/ServiceDescription";
import ServiceRequestedDetails from "../views/ServiceRequestedDetails/ServiceRequestedDetails";
import ExampleAppForm from "../views/ExampleAppForm/ExampleAppForm";
import { MyConfiguration } from "../views/MyConfiguration/MyConfiguration";
import ActivateAccount from "../views/Auth/ActivateAccount/ActivateAccount";
import ValidatePayment from "../views/ValidatePayment/ValidatePayment";
import AllServices from "../views/AllServices/AllServices";
import FrequentQuestions from "../views/FrequentQuestions/FrequentQuestions";
import TermsOfUse from "../views/TermsOfUse/TermsOfUse";
import Guide from "../views/Guide/Guide";
import UserValidation from "../views/UserValidation/UserValidation";
import ValidateToken from "../views/ValidateToken/ValidateToken";
import ResetPassword from "../views/Auth/ResetPassword/ResetPassword";




const routes = [
  //PUT ALL loginRequired:false OBJECTS ROUTES on TOP of array
  {
    path: "/home",
    component: Home,
    exact: true,
    layout: "/app",
    loginRequired: false,
  },
  {
    path: "/login",
    component: Login,
    exact: true,
    layout: "/public",
    loginRequired: false,
  },
  {
    path: "/register",
    component: Register,
    exact: true,
    layout: "/app",
    loginRequired: false,
  },

  {
    path: "/requestPassword",
    component: RequestPassword,
    exact: true,
    layout: "/public",
    loginRequired: false,
  },
  {
    path: "/resetPassword/:token",
    component: ResetPassword,
    exact: true,
    layout: "/public",
    loginRequired: false,
  },

  {  // FOR SEE ALL FORM FIELDS AND COMPONENTS
    path: "/TESTFORM",
    component: ExampleAppForm,
    exact: true,
    layout: "/app",
    loginRequired: false,
  },
  {
    path: "/activateAccount/:activationToken",
    component: ActivateAccount,
    exact: true,
    layout: "/app",
    loginRequired: false,
  },
  {
    path: "/allServices",
    component: AllServices,
    exact: true,
    layout: "/app",
    loginRequired: false,
  },
  {
    path: "/serviceDescription/:serviceID",
    component: ServiceDescription,
    exact: true,
    layout: "/app",
    loginRequired: false,
  },
  {
    path: "/listOfServices/:categoryID",
    component: ListOfServicesPerCategory,
    exact: true,
    layout: "/app",
    loginRequired: false,
  },
  {
    path: "/alcaldias",
    component: AlcaldiasList,
    exact: true,
    layout: "/app",
    loginRequired: false,
  },
  {
    path: "/alcaldias/:alcaldiaId",
    component: AlcaldiaView,
    exact: true,
    layout: "/app",
    loginRequired: false,
  },
  {
    path: "/validateToken/:code",
    component: ValidateToken,
    exact: false,
    layout: "/app",
    loginRequired: false,
  },
  {
    path: "/contact",
    component: Contact,
    exact: true,
    layout: "/app",
    loginRequired: false,
  },
  {
    path: "/guide",
    component: Guide,
    exact: true,
    layout: "/app",
    loginRequired: false,
  },
  {
    path: "/policy",
    component: PolicyPrivacy,
    exact: true,
    layout: "/app",
    loginRequired: false,
  },
  {
    path: "/frequentQuestions",
    component: FrequentQuestions,
    exact: true,
    layout: "/app",
    loginRequired: false,
  },
  {
    path: "/termsOfUse",
    component: TermsOfUse,
    exact: true,
    layout: "/app",
    loginRequired: false,
  },
  {
    path: "/myDesk",
    component: MyDesk,
    exact: true,
    layout: "/app",
    loginRequired: true,
  },
  {
    path: "/myConfiguration",
    component: MyConfiguration,
    exact: true,
    layout: "/app",
    loginRequired: true,
  },

  {
    path: "/UserValidation/:serviceID",
    component: UserValidation,
    exact: true,
    layout: "/app",
    loginRequired: true,
  },

  {
    path: "/requestService/:serviceID",
    component: RequestService,
    exact: true,
    layout: "/app",
    loginRequired: true,
  },
  {
    path: "/serviceRequestedDetails/:requestID",
    component: ServiceRequestedDetails,
    exact: true,
    layout: "/app",
    loginRequired: true,
  },

  /*
  {
    path: "/requestedServicesList/:servicesStatus",
    component: RequestedServiceList,
    exact: true,
    layout: "/app",
    loginRequired: true,
  },
  */
  {
    path: "/validatePayment/:requestID",
    component: ValidatePayment,
    exact: false,
    layout: "/app",
    loginRequired: false,
  },
  {
    path: "*",
    layout: "/app",
    component: () => <Redirect to="/app/home" />,
  },

  {
    path: "*",
    layout: "/public",
    component: () => <Redirect to="/app/home" />,
  },

];

export default routes;
